var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "target_3_",
    "data-name": "target (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.924,
    height: 20.924,
    viewBox: "0 0 20.924 20.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60525",
    "data-name": "Group 60525",
    transform: "translate(9.262 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60524",
    "data-name": "Group 60524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87726",
    "data-name": "Path 87726",
    d: "M211.286,1.883l-1.362.195.195-1.362a.625.625,0,0,0-1.06-.53l-2.5,2.5a.625.625,0,0,0-.177.353l-.283,1.98L203.015,8.1a1.853,1.853,0,0,0-.8-.188,1.874,1.874,0,1,0,1.874,1.874,1.852,1.852,0,0,0-.188-.8L206.984,5.9l1.98-.283a.625.625,0,0,0,.353-.177l2.5-2.5A.625.625,0,0,0,211.286,1.883Z",
    transform: "translate(-200.338 -0.001)",
    fill: "#66939f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60527",
    "data-name": "Group 60527",
    transform: "translate(4.584 5.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60526",
    "data-name": "Group 60526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87727",
    "data-name": "Path 87727",
    d: "M110.861,114.538l-1.979,1.979a3.151,3.151,0,1,1-2.65-2.65l1.979-1.979a5.644,5.644,0,1,0,2.65,2.65Z",
    transform: "translate(-100.171 -111.334)",
    fill: "#66939f"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60529",
    "data-name": "Group 60529",
    transform: "translate(0 0.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60528",
    "data-name": "Group 60528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87728",
    "data-name": "Path 87728",
    d: "M19.544,17.082,19,17.629a2.062,2.062,0,0,1-1.16.58l-.741.106a7.542,7.542,0,1,1-3.735-3.735l.106-.741a2.064,2.064,0,0,1,.58-1.16l.546-.546a10.263,10.263,0,1,0,4.951,4.95Z",
    transform: "translate(-0.003 -11.166)",
    fill: "#66939f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget2);
export default __webpack_public_path__ + "static/media/target2.3e4047cfdb190f7c654d2b97e3c5ae16.svg";
export { ForwardRef as ReactComponent };